// extracted by mini-css-extract-plugin
export default {"menuArea":"VideoMenu_menuArea__TG3Sd","menu":"VideoMenu_menu__-DmVS","nomenu":"VideoMenu_nomenu__c5WHC"};